// extracted by mini-css-extract-plugin
export default {"wrapper":"image-gallery-module--wrapper--1d766","item":"image-gallery-module--item--8b2f0"};